exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-btn-toggle[data-v-1af173ae] {\n    flex-direction: column;\n}\n.v-expansion-panel[data-v-1af173ae]::before {\n    box-shadow: none;\n}\n", ""]);
